import { useTranslation } from 'react-i18next';

import { ErrorState } from '@nucleus-commerce/admin-kit/errors';
import { FormSection } from '@nucleus-commerce/admin-kit/forms';
import { Skeleton } from '@nucleus-commerce/ui/components/skeleton';

import { useCollectionProducts } from '../hooks/use-collection';

import { CollectionProductRow } from './collection-product-row';

export interface CollectionProductsListProps {
  storeId: string;
  collectionId: string;
}

/** Read-only materialised list of an automated collection. */
export function CollectionProductsList({ storeId, collectionId }: CollectionProductsListProps) {
  const { t } = useTranslation('collections');
  const query = useCollectionProducts(storeId, collectionId);

  return (
    <FormSection
      title={t('sections.materialised')}
      description={t('sections.materialisedDescription')}
    >
      {query.isPending ? (
        <div className="flex flex-col gap-2" aria-busy>
          <Skeleton className="h-10" />
          <Skeleton className="h-10" />
        </div>
      ) : query.isError ? (
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      ) : query.data.length === 0 ? (
        <p className="text-muted-foreground text-sm">{t('products.emptyAutomated')}</p>
      ) : (
        <ol className="divide-y rounded-md border" aria-label={t('sections.materialised')}>
          {query.data.map((item) => (
            <CollectionProductRow key={item.productId} item={item} />
          ))}
        </ol>
      )}
    </FormSection>
  );
}
